/* Olivia-style PDP layout fixer.
 * 1) Restructures Prestige's buy-buttons DOM so quantity-selector sits next to ATC.
 * 2) Relocates the See-it-in-action section into the product-info column.
 * 3) Auto-hides the sticky ATC bar when the footer aside (payment icons) is visible.
 * Re-applies after product-info re-renders (variant changes). */
(function () {
  'use strict';

  // --- 1) qty + ATC side-by-side ---
  function applyLayout() {
    var qtyBlock = document.querySelector(
      '.product-info__block-item[data-block-type="quantity-selector"]:not([data-olivia-restructured])'
    );
    if (!qtyBlock) return;

    var qtyInner = qtyBlock.querySelector('quantity-selector');
    if (!qtyInner) return;

    var buyBlock = document.querySelector(
      '.product-info__block-item[data-block-type="buy-buttons"]'
    );
    if (!buyBlock) return;

    var buyButtons = buyBlock.querySelector('buy-buttons');
    if (!buyButtons) return;

    var atc =
      buyButtons.querySelector('button[type="submit"]') ||
      buyButtons.querySelector('.button--primary') ||
      buyButtons.querySelector('button.button');
    if (!atc) return;

    var row = document.createElement('div');
    row.className = 'olivia-qty-atc-row';
    row.appendChild(qtyInner);
    row.appendChild(atc);

    buyButtons.insertBefore(row, buyButtons.firstChild);

    qtyBlock.style.display = 'none';
    qtyBlock.setAttribute('data-olivia-restructured', 'true');
  }

  // --- 2) See it in action: move into product-info column ---
  function relocateSeeItInAction() {
    var siia = document.querySelector(
      'section[id*="see_it_in_action"]:not([data-olivia-siia-relocated])'
    );
    if (!siia) return;

    var description = document.querySelector(
      '.product-info__block-list > .product-info__block-item[data-block-type="description"]'
    );
    if (description) {
      description.parentNode.insertBefore(siia, description);
    } else {
      var offers = document.querySelector(
        '.product-info__block-list > .product-info__block-item[data-block-type="offers"]'
      );
      if (!offers) return;
      offers.parentNode.insertBefore(siia, offers.nextSibling);
    }

    siia.classList.add('olivia-siia-relocated');
    siia.setAttribute('data-olivia-siia-relocated', 'true');
  }

  // --- 3) Sticky ATC auto-hide when footer aside (payment icons) is visible ---
  function setupStickyAtcAutoHide() {
    var stickyBar = document.querySelector('product-sticky-bar, .product-sticky-bar');
    if (!stickyBar || typeof IntersectionObserver === 'undefined') return;

    var trigger =
      document.querySelector('.footer .footer__aside') ||
      document.querySelector('.footer .payment-methods') ||
      document.querySelector('footer.shopify-section .footer__aside');

    if (!trigger) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('olivia-sticky-hidden', entry.isIntersecting);
      });
    }, { rootMargin: '0px', threshold: 0 });

    obs.observe(trigger);
  }

  function init() {
    applyLayout();
    relocateSeeItInAction();
    setupStickyAtcAutoHide();

    var infoRoots = document.querySelectorAll('.product-info, product-rerender');
    if (!infoRoots.length || typeof MutationObserver === 'undefined') return;

    var debounce;
    var obs = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () {
        applyLayout();
        relocateSeeItInAction();
      }, 30);
    });
    infoRoots.forEach(function (root) {
      obs.observe(root, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
